<template>

<router-view></router-view>


</template>
<script>
  export default {
    name:'root',
    mounted(){
      let urlParamObject = {};
      let url = document.location.search;
      //древнее мамонта хрень для парсинга входяшиз get параметров
      if (url != undefined && url.length > 1) {
        if (url[0] == '?') {
          url = url.slice(1);
        }
        let urlParam = url.split('&');
        for (let i = 0; i < urlParam.length; i+=1) {
          let param = urlParam[i].split('=');
          if (param[0] != undefined && param[1] != undefined) {
            urlParamObject[param[0]] = param[1];
          }
        }
      }

      this.$store.dispatch('AdditionalInfoAdd',urlParamObject);

      // получаем id session для дальнешего логирования
      this.$myApi.singleRequest({'action':'getSession','AdditionalInfo':urlParamObject})
        .then((res)=>{
          this.$store.dispatch('addSession',res.session);
        })
        .catch((res)=>{
          res['asd'] = 'asd';
          //что то сломалось
          this.$store.dispatch('addSession',0);
        });
    }
  }
</script>


<style>


</style>
